// extracted by mini-css-extract-plugin
module.exports = {"bottomParagraph":"DeleteDocumentFolderPopUp_bottomParagraph__2GND1"};